import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// === CRITICAL PERFORMANCE: Inject preconnect + non-blocking fonts + image preload BEFORE React renders ===
// 1. Preconnect to Google Fonts (saves DNS + TLS time)
const preconnect1 = document.createElement('link');
preconnect1.rel = 'preconnect';
preconnect1.href = 'https://fonts.googleapis.com';
document.head.appendChild(preconnect1);
const preconnect2 = document.createElement('link');
preconnect2.rel = 'preconnect';
preconnect2.href = 'https://fonts.gstatic.com';
preconnect2.crossOrigin = 'anonymous';
document.head.appendChild(preconnect2);
// 2. Preload hero image (LCP element)
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/921ZXerDwyfauhtmYMPMc4/libro_abanico_todos_los_productos_sin_fondo.png';
document.head.appendChild(preloadImg);
// 3. Load Google Fonts NON-BLOCKING (media="print" trick)
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Montserrat:wght@700;900&family=Open+Sans:wght@400;600;700&display=swap';
fontLink.media = 'print';
fontLink.onload = function () {
  ;
  (this as HTMLLinkElement).media = 'all';
};
document.head.appendChild(fontLink);
// === END PERFORMANCE INJECTIONS ===
render(<App data-id="element-266" />, document.getElementById('root'));